import * as React from 'react';
import { Admin, Resource } from "react-admin";
import { FaqList } from '../faq/FaqList';
import { dataProvider } from "../dataProvider/dataProvider";
import { AdminLayout } from '../layout/AdminLayout';
import { FaqEdit } from "../faq/FaqEdit";
import { FaqCreate } from "../faq/FaqCreate";
import { CarEdit } from "../car/CarEdit";
import { CarCreate } from "../car/CarCreate";
import { CarList } from "../car/CarList";
import { CarRentList } from "../carRent/CarRentList";
import { CarRentEdit } from "../carRent/CarRentEdit";
import { ContactsList } from "../contacts/ContactsList";
import { HomeBannersList } from "../homeBanners/HomeBannersList";
import { HomeBannersEdit } from "../homeBanners/HomeBannersEdit";
import { HomeBannersCreate } from "../homeBanners/HomeBannersCreate";
import { CarTuningList } from "../carTuning/CarTuningList";
import { CarTuningEdit } from "../carTuning/CarTuningEdit";
import { CarTuningCreate } from "../carTuning/CarTuningCreate";
import { ContentList } from "../content/ContentList";
import { ContentEdit } from "../content/ContentEdit";
import { ContentCreate } from "../content/ContentCreate";
import { OurContactList } from "../ourContacts/OurContactList";
import { OurContactEdit } from "../ourContacts/OurContactEdit";
import { OurContactCreate } from "../ourContacts/OurContactCreate";
import { LifestyleList } from "../lifestyle/LifestyleList";
import { LifestyleEdit } from "../lifestyle/LifestyleEdit";
import { LifestyleCreate } from "../lifestyle/LifestyleCreate";
import authProvider from "../authProvider/authProvider";
import { GalleryList } from "../gallery/GalleryList";
import { GalleryEdit } from "../gallery/GalleryEdit";
import { GalleryCreate } from "../gallery/GalleryCreate";
import { PartnersList } from "../partners/PartnersList";
import { PartnersEdit } from "../partners/PartnersEdit";
import { PartnersCreate } from "../partners/PartnersCreate";
import { TranslationsList } from "../translations/TranslationsList";
import { TranslationsEdit } from "../translations/TranslationsEdit";
import { TranslationsCreate } from "../translations/TranslationsCreate";

const App = () => (
  <Admin layout={AdminLayout} authProvider={authProvider} dataProvider={dataProvider}>
      <Resource name="homeBanners" list={HomeBannersList} edit={HomeBannersEdit} create={HomeBannersCreate} />
      <Resource name="galleries" list={GalleryList} edit={GalleryEdit} create={GalleryCreate} />
      <Resource name="partners" list={PartnersList} edit={PartnersEdit} create={PartnersCreate} />
      <Resource name="translations" list={TranslationsList} edit={TranslationsEdit} create={TranslationsCreate} />
      <Resource name="car" list={CarList} edit={CarEdit} create={CarCreate} />
      <Resource name="carTuning" list={CarTuningList} edit={CarTuningEdit} create={CarTuningCreate} />
      <Resource name="faq" list={FaqList} edit={FaqEdit} create={FaqCreate} />
      <Resource name="content" list={ContentList} edit={ContentEdit} create={ContentCreate} />
      <Resource name="ourContact" list={OurContactList} edit={OurContactEdit} create={OurContactCreate} />
      <Resource name="lifestyle" list={LifestyleList} edit={LifestyleEdit} create={LifestyleCreate} />
      <Resource name="carRent" list={CarRentList} edit={CarRentEdit} />
      <Resource name="contacts" list={ContactsList} />
  </Admin>
);

export default App;
